<template>
  <v-card>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline primary--text text--darken-1">{{ name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-img
      :src="img"
      aspect-ratio="1.7"
    ></v-img>

    <v-card-text>
      {{ info }}
    </v-card-text>

    <v-card-actions class="d-flex align-center justify-center">
      <v-btn
        v-for="(link, n) in links"
        v-bind:key="n"
        x-large
        text
        :color="link.color"
        :href="link.url"
      >
        {{ link.text }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['name', 'img', 'info', 'links']
}
</script>
